import { render, staticRenderFns } from "./DlgEventEdit.vue?vue&type=template&id=82f49ed2&scoped=true"
import script from "./DlgEventEdit.vue?vue&type=script&lang=js"
export * from "./DlgEventEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f49ed2",
  null
  
)

export default component.exports